import CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';

import {
  HOST_URL,
  AUTHORIZATION_URL,
  AUTHORIZATION_CLIENT_ID,
} from '../../helpers';

import {
  MARKETPLACE_OAUTH2_STATE,
  MARKETPLACE_CODE_CHALLENGE,
  REDIRECT_URL,
  MARKETPLACE_DEV_CONTEXT,
  MARKETPLACE_GWT,
  MARKETPLACE_GWT_ID,
  MARKETPLACE_DEV_DEACTIVATED,
} from './constants';

import { TParsedTokenId } from './auth.types';

export const getRandomString = (length = 25): any =>
  CryptoJS.lib.WordArray.random(length);

export const getAuthRedirectURL = (): string => {
  let code_challenge = localStorage.getItem(MARKETPLACE_CODE_CHALLENGE);
  let state = localStorage.getItem(MARKETPLACE_OAUTH2_STATE);

  if (!code_challenge || !state) {
    localStorage.setItem(MARKETPLACE_CODE_CHALLENGE, getRandomString());
    localStorage.setItem(MARKETPLACE_OAUTH2_STATE, getRandomString());
  }

  code_challenge = localStorage.getItem(MARKETPLACE_CODE_CHALLENGE);
  state = localStorage.getItem(MARKETPLACE_OAUTH2_STATE);

  return `${AUTHORIZATION_URL}/auth-code?client_id=${AUTHORIZATION_CLIENT_ID}&redirect_uri=${HOST_URL}/${REDIRECT_URL}&response_type=code&scope=openid&code_challenge=${code_challenge}&code_challenge_method=plain&state=${state}`;
};

export const logOut = async (redirected = true,redirectUrl="") => {
  const token = localStorage.getItem(MARKETPLACE_GWT);
  const token_id = localStorage.getItem(MARKETPLACE_GWT_ID);

  if (token && token_id !== undefined && token_id !== null) {
    const parsedTokenId: TParsedTokenId = jwt_decode(token_id || '');
    await fetch(`${AUTHORIZATION_URL}/signout/`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id: parsedTokenId['pi.sri'] }),
    });
  }

  localStorage.removeItem(MARKETPLACE_GWT);
  localStorage.removeItem(MARKETPLACE_GWT_ID);
  localStorage.removeItem(MARKETPLACE_CODE_CHALLENGE);
  localStorage.removeItem(MARKETPLACE_OAUTH2_STATE);
  localStorage.removeItem(MARKETPLACE_DEV_CONTEXT);
  localStorage.removeItem(MARKETPLACE_DEV_DEACTIVATED);

  if (redirected) {
    window.location.href = redirectUrl.length > 0 ? redirectUrl : getAuthRedirectURL();
  }
};
